export const pattern = {
  normal_text: { pattern: "^.{3,100}$", message: "Minimum 3 karakter megadása kötelező!" },
  number: { pattern: "^[0-9.]{1,20}$", message: "Csak számok, max. 20 karakter!" },
  vat: {
    pattern: ".{8,20}$",
    message: "Minimum 8 karakter szükséges!",
  },
  zip: {
    pattern: "^[0-9]{4,100}$",
    message: "Csak számok, 4 karakter szükséges!",
  },
  phone: {
    pattern: "^(?:\\+36|06|)[\\s-]?[0-9]{1,2}[\\s-][0-9]{3}[\\s-][0-9]{3,4}$",
    message: "Formátum: +36 30 123 4567 vagy 06 30 123 4567",
  },
  email: {
    pattern: "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$",
    message: "Adjon meg érvényes e-mailcímet!",
  },
  money: "^(?:1000000|[1-9]\\d{0,5}|0)(?:\\.\\d{1,2})?$",
  money_error: "Szám, max. 1 000 000, max. 2 tízedesig",
};
